import { useState } from 'react';
import { Copy, Eye, EyeOff, Wand2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { generatePassword } from './password';

/** Campo de senha temporária com gerar/mostrar/copiar: o admin entrega a senha ao usuário. */
export function PasswordInput({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
}) {
  const [show, setShow] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    toast.success('Senha copiada');
  };
  return (
    <div className="flex gap-1">
      <Input
        id={id}
        type={show ? 'text' : 'password'}
        autoComplete="new-password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="font-mono"
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        title={show ? 'Ocultar' : 'Mostrar'}
        onClick={() => setShow((s) => !s)}
      >
        {show ? <EyeOff /> : <Eye />}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title="Gerar senha"
        onClick={() => {
          onChange(generatePassword());
          setShow(true);
        }}
      >
        <Wand2 />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title="Copiar"
        disabled={!value}
        onClick={copy}
      >
        <Copy />
      </Button>
    </div>
  );
}
